/* src/app/components/doc-viewer-new/doc-viewer-context-panel-template/email-threading-context-panel/email-threading-context-panel.component.scss */
.background-highlight {
  background-color: whitesmoke;
}
:host-context(.dark-theme) .background-highlight {
  background-color: rgba(255, 255, 255, 0.06);
}
.link-container {
  padding: 5px;
}
/*# sourceMappingURL=email-threading-context-panel.component.css.map */
